export default __webpack_public_path__ + "static/media/reference-digital-establecimiento.1bf21a32.svg";